import type { z } from 'zod'

import type { ApiRequest } from '~/types/ApiRequest'
import type { ApiRequestOptions } from '~/types/ApiRequestOptions'
import { parseResponse } from '~/utils/parseResponse'
import { strictify } from '~/utils/strictify'

export const requestAndParse = async <Schema extends z.ZodType>(
  client: ApiRequest,
  schema: Schema,
  url: string,
  options?: ApiRequestOptions
): Promise<z.output<Schema>> => parseResponse(strictify(schema), await client(url, options), url)
